import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=ed05b0f4&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"
import style0 from "./Audio.vue?vue&type=style&index=0&id=ed05b0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed05b0f4",
  null
  
)

export default component.exports